import {useState, useEffect, useCallback, useRef} from 'react';
import './Drawcanvas.css';
import { useSelector, useDispatch } from 'react-redux'
import { addMessage } from './redux/gameState';

function ChatInput (props) {
  const dispatch = useDispatch();
  const playerState = useSelector((state) => state.playerState);
  const [message, setMessage] = useState("");
  const socket = props.socket;
  const inputRef = useRef(null);

  useEffect(() => {
    socket.once("updateMessage", (msg) => {
      dispatch(addMessage(msg))
    });
    return () => {
      socket.off('updateMessage');
   };
  });

  const handleChange = useCallback((e) => {
    // Update state immediately for controlled input
    setMessage(e.target.value);
  }, []);

  function handleSubmit(e) {
    e.preventDefault();
    if (message.trim() === ""){
      return;
    }
    let msg = {
      "author": playerState,
      "text" : message,
      "authId": playerState.id
    }
    dispatch(addMessage(msg));
    socket.emit("newMessage", msg);
    setMessage("");
    if (inputRef.current) {
      inputRef.current.focus();
      inputRef.current.value = "";
    }
  };

  return (
    <form className="md:mb-3 mb-1 ml-1 pt-0 flex items-center">
      <input 
        ref={inputRef}
        maxLength="120" 
        onChange={handleChange} 
        type="text" 
        placeholder="Type a message here" 
        className="w sm:rounded-xl px-3 py-3 placeholder-blueGray-300 text-blueGray-600 relative bg-white bg-white rounded text-sm border-0 shadow outline-none focus:outline-none focus:ring w-full"
      />
      <button onClick={handleSubmit} type="submit" value="Submit" className="md:m-3 bg-green-500 hover:bg-green-700 text-white font-bold py-2 px-4 rounded">Send</button>
    </form>
  );
};

export default ChatInput;
